import React from 'react';
import { bidUnitList } from '../../../Store';

const BidHistory = ({ bidHistory, onClick }) => {
    
    const getNameById = (entryUnit) => {
        const item = bidUnitList.find((item) => entryUnit == item.id);
        return item ? item.name : 'Not Found';
    }
    const entryUnitName = getNameById(bidHistory.entryUnit);

    //===============================================
    // Css
    //===============================================
    const container = {
        backgroundColor:'#fff',borderBottom : '1px solid #ababab',padding : '10px', width: '100%', marginBottom: '10px'
    };
    return (
        
            <div style={{borderRadius : '10px', width: '100%'}}>
                <div style={container} onClick={ onClick}>
                    <div style={{marginLeft:'0em'}}>
                        <div>
                            <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'bold'}}>{`【${ bidHistory.entryUser }】`}</div>
                            { bidHistory.bidStatus === 9 ? (<div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left'}}>札入なし</div>) 
                            : (<div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left'}}>{`単価：${bidHistory.tanka}円 / 数量：${ bidHistory.entrySuryo ? bidHistory.entrySuryo : '' }${ entryUnitName }`}</div>)}
                            <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left'}}>{`条件：${ bidHistory.condition }`}</div>
                        </div>
                    </div>
                </div>
            </div>
        
    )
  }
  
  export default BidHistory;